import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Timetable from "./views/Timetable.vue";
import AllOffers from "./views/AllOffers.vue";
import Login from "@/components/auth/Login.vue";
import addOffer from "@/components/offer/addOffer.vue";
import merchantList from "@/components/merchants/merchantList";
import outletList from "@/components/outlets/outletList";
import offerFilter from "@/components/offer/offerFilter";
import imageCropper from "@/components/cropper/imageCropper";

import axios from "axios";

Vue.use(Router);

export const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },

    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        public: true
      }
    },

    {
      path: "/timetable",
      name: "timetable",
      component: Timetable
    },

    // OFFER ROUTES

    {
      path: "/allOffers",
      name: "allOffers",
      component: AllOffers
    },

    {
      path: "/addOffer",
      name: "addOffer",
      component: addOffer,
      meta: { hideSearch: true },
      props: true
    },

    // MERCHANT ROUTES

    {
      path: "/merchantList",
      name: "merchantList",
      component: merchantList
    },

    // OUTLET ROUTES

    {
      path: "/outletList",
      name: "outletList",
      component: outletList
    },

    {
      path: "**",
      redirect: "/"
    }
  ]
});

router.beforeEach((to, from, next) => {
  const authRequired = !to.meta.public;
  const user = JSON.parse(localStorage.getItem("user"));

  const token = localStorage.getItem("token");
  if (token) {
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
  }
  //Check if logged in
  if (authRequired && !user && !token) {
    return next("/login");
  }
  //Already logged in
  if (!authRequired && user && token) {
    return next("/");
  }

  next();
});
